import { useNavigate, useParams } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';

export function NotFoundPage() {
  const { tenantSlug } = useParams<{ tenantSlug: string }>();
  const navigate = useNavigate();

  return (
    <div className="min-h-dvh bg-gray-50 flex flex-col items-center justify-center px-4 text-center">
      <div className="bg-white rounded-2xl shadow-sm p-10 max-w-sm w-full">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
            <ShoppingBag className="w-8 h-8 text-orange-500" />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Página não encontrada</h1>
        <p className="text-gray-500 mb-6">
          O endereço que você acessou não existe ou foi removido.
        </p>
        {tenantSlug ? (
          <button
            onClick={() => navigate(`/${tenantSlug}`)}
            className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 rounded-xl transition-colors"
          >
            Voltar à loja
          </button>
        ) : (
          <p className="text-sm text-gray-400">Verifique o link recebido e tente novamente.</p>
        )}
      </div>
    </div>
  );
}
